import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import '../styles.scss';
import './styles.scss';
import BoxWithCollapse from '../../BoxWithCollapse';
import COOKIES, { removeCookie, setCookieTenYearsFromNow } from '../../../utils/cookies';
import StyledLink from '../../StyledLink';

export const ALWAYS_ACTIVE = 'always';

const CookiesAcceptationModal = ({ cookieState, cookies, onCloseModal, onMorePreferences }) => {
  const { t } = useTranslation();
  const { COOKIE_NECESSARY, COOKIE_ANALYTICS, GOOGLE_ANALYTICS_OPT_OUT } = COOKIES;
  const [analyticsActivated, setAnalyticsActivated] = useState(cookies.get(COOKIE_ANALYTICS));

  const onMoreChoicesClick = () => {
    onMorePreferences();
  };

  const onConfirmPreferences = async () => {
    setCookie(COOKIE_NECESSARY);

    if (analyticsActivated) {
      setCookie(COOKIE_ANALYTICS);
      removeCookie(GOOGLE_ANALYTICS_OPT_OUT, cookies);
    } else {
      removeCookie(COOKIE_ANALYTICS, cookies);
      setCookie(GOOGLE_ANALYTICS_OPT_OUT);
    }

    onCloseModal();
  };

  const setCookie = key => {
    setCookieTenYearsFromNow(key, true, cookies);
  };

  const onAllCookiesAccepted = async () => {
    setCookie(COOKIE_NECESSARY);
    setCookie(COOKIE_ANALYTICS);

    onCloseModal();
  };

  const onAnalyticsActiveChange = activated => {
    setAnalyticsActivated(activated);
  };

  const closeModal = () => {
    setAnalyticsActivated(cookies.get(COOKIE_ANALYTICS));
    onCloseModal();
  };

  const onRequiredOnlyClick = async () => {
    setCookie(COOKIE_NECESSARY);
    removeCookie(COOKIE_ANALYTICS, cookies);
    setCookie(GOOGLE_ANALYTICS_OPT_OUT);

    onCloseModal();
  };

  return (
    <>
      {!cookieState.moreChoice && (
        <Modal className="styled-modal" centered isOpen={cookieState.isOpen} fade={false} backdrop="static" size="lg">
          <ModalHeader className="styled-header">
            <div className="styled-modal-title">{t('cookieModals.acceptanceTitle')}</div>
          </ModalHeader>
          <ModalBody className="styled-modal-body">
            <p className="text-main-cookie">
              {t('cookieModals.acceptanceDescription')}{' '}
              <StyledLink className="cursor-pointer" onClick={onMoreChoicesClick}>
                {t('cookieModals.acceptanceMoreChoicesButton')}.
              </StyledLink>
            </p>
          </ModalBody>
          <ModalFooter className="styled-modal-footer">
            <button className="modal-button" variant="modal" color="outline" onClick={onRequiredOnlyClick}>
              {t('cookieModals.acceptanceSubmitRequiredButton')}
            </button>
            <button className={`modal-button primary`} color="black" onClick={onAllCookiesAccepted}>
              {t('cookieModals.acceptanceSubmitButton')}
            </button>
          </ModalFooter>
        </Modal>
      )}
      {cookieState.moreChoice && (
        <Modal centered isOpen={cookieState.moreChoice} backdrop="static" size="lg">
          {cookies.get(COOKIE_NECESSARY) && <ModalHeader className="styled-header" toggle={() => closeModal()} />}
          <ModalHeader className="styled-header">
            <div className="styled-modal-title">{t('cookieModals.settingsTitle')}</div>
          </ModalHeader>
          <ModalBody
            className={`${cookies.get(COOKIE_NECESSARY) && 'settings'} styled-modal-body`}
            style={{ padding: '0 50px' }}
          >
            <BoxWithCollapse t={t} title={t('cookieModals.necessaryTitle')} active={ALWAYS_ACTIVE}>
              <p className="text-cookie-description" insideCollapse={true}>
                {t('cookieModals.necessaryDescription')}
              </p>
            </BoxWithCollapse>
            <BoxWithCollapse
              title={t('cookieModals.analyticsTitle')}
              t={t}
              preferencesConfirmed={analyticsActivated}
              onFunctionalActiveChange={onAnalyticsActiveChange}
            >
              <p className="text-cookie-description">{t('cookieModals.analyticsDescription')}</p>
            </BoxWithCollapse>
          </ModalBody>
          <ModalFooter className="styled-modal-footer" just-button="true">
            <button className={`modal-button primary`} color="black" onClick={onConfirmPreferences}>
              {t('cookieModals.settingsSubmitButton')}
            </button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default CookiesAcceptationModal;
